import { apiService } from "@/common/api.service.js";

export default {
// Get all actions
  getAllActions() {
    let endpoint = `/api/action-all/`;
    return apiService(endpoint);
  },
// Search action query
  searchActionQuery(searchQuery) {
    let endpoint = `/api/actions/?search=${searchQuery}`;
    return apiService(endpoint);
  },
// Get action details
  actionData(actionId) {
    let endpoint = `/api/actions/${actionId}/`;
    return apiService(endpoint);
  },
// Create Action
  actionCreate(payload) {
    let endpoint = `/api/action-create/`;
    return apiService(endpoint, "POST", payload)
  },
// Update Action
  actionUpdate(payload) {
    let endpoint = `/api/action-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },
// Change Action Status
  changeActionStatus(payload) {
    let endpoint = `/api/action-status/${payload.id}/`;
    return apiService(endpoint, "POST", payload)
  },
// Change Action Graph Type
  changeActionGraphType(payload) {
    let endpoint = `/api/action-graph/${payload.id}/`;
    return apiService(endpoint, "POST", payload)
  },
// Create Enpi-Action relation
  createEnpiActionRelation(payload) {
    let endpoint = `/api/enpi-action/${payload.id}`;
    return apiService(endpoint, "POST", payload)
  },
// Action Comments
  actionComments(actionNumber) {
    let endpoint = `/api/action-comment/${actionNumber}`;
    return apiService(endpoint);
  },
// Add Comment
  createActionComment(payload) {
    let endpoint = `/api/action-comment/${payload.action_number}`;
    return apiService(endpoint, "POST", payload);
  },
// Update Response
  updateActionResponse(payload) {
    let endpoint = `/api/action-response/${payload.action_number}/`;
    return apiService(endpoint, "POST", payload);
  },
}